import { CLEAR_SITE_AP_USAGE_GRAPH, SAVE_SITE_AP_MAX_MIN_USAGE_GRAPH_DATA, SITE_AP_MAX_MIN_USAGE_GRAPH_LOADING } from "../../constants/graphConstants/customerAggrStatsGraphConstants";
/**
 * Reducer function for managing the Site APs Max-Min Data Usage graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const siteApsDataUsageGraphReducer = (state = {
    loading: false,
    dataUsage: {
        min: [],
        max: []
    }
}, action) => {
    switch (action.type) {
        case SAVE_SITE_AP_MAX_MIN_USAGE_GRAPH_DATA:
            return {
                ...state,
                loading: false,
                dataUsage: {
                    ...state.dataUsage,
                    [action.payload.usageType]: action.payload.data
                }
            };
        case SITE_AP_MAX_MIN_USAGE_GRAPH_LOADING:
            return {
                ...state,
                // dataUsage: {},
                loading: action.payload,
                dataUsage : {
                    ...state.dataUsage,
                    [action.payload] : []
                }
            };
        case CLEAR_SITE_AP_USAGE_GRAPH:
            return {
                ...state,
                dataUsage: {
                    ...state.dataUsage,
                    [action.payload.usageType]: []
                }
            };
        default:
            return state;
    }
};